<template>
    <div v-if="!loading">
        <div class="row">
            <div class="col text-right mb-2">
                <b-button class="mr-sm-1 mr-md-1" :href="$routes.route('rentaltype.create')"><i class="far fa-fw fa-plus"></i>
                    Create</b-button>
            </div>
        </div>
        <!-- <h1>Rental Types</h1> -->

        <div class="row mb-2">
            <div class="col-lg col-md-12 mx-sm-1 ml-lg-2 mr-lg-1 mb-md-0 mb-lg-2">
                <b-card class="mb-md-2 mb-lg-0">
                    <b-card-title title-tag="h5" title="Rental Types"></b-card-title>
                    <b-card-body class="px-0">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <!-- <th>ID</th> -->
                                    <th class="col-3">Name</th>
                                    <th class="col-2">Price (&pound;)</th>
                                    <th class="col-2">Site</th>
                                    <td class="col-2">Limits</td>
                                    <th class="col-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="rentalType in rentalTypes" :key="rentalType.id">
                                    <!-- <td>{{ rentalType.id }}</td> -->
                                    <td class="col-3">{{ rentalType.name }}</td>
                                    <td class="col-2">{{ (rentalType.price / 100).toFixed(2) }}</td>
                                    <td class="col-2">{{ rentalType.site.title }}</td>
                                    <td class="col-2">{{ (rentalType.unlimited) ? 'Unlimited' : rentalType.qty }}</td>
                                    <td class="col-3">
                                        <b-button type="button" :href="$routes.route('rentaltype.edit', {'rentalType': rentalType.id})" class="btn btn-primary"> <i class="fas fa-fw fa-edit"></i>Edit</b-button>
                                        <button v-if="! rentalType.disabled" class="btn btn-danger" @click="toggleRentalTypeStatus(rentalType)"><i class="far fa-fw fa-ban"></i> Disable</button>
                                        <button v-if="rentalType.disabled" class="btn btn-success" @click="toggleRentalTypeStatus(rentalType)"><i class="far fa-fw fa-check"></i> Enable</button>
                                        <button class="btn btn-danger" @click="deleteRentalType(rentalType)"><i class="fas fa-fw fa-trash-alt"></i> Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rentalTypes: [],
            loading: true,
        }
    },
    methods: {
        fetchRentalTypes() {
            axios.get(this.$routes.route('rentaltype.index'))
                .then(response => {
                    this.rentalTypes = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        toggleRentalTypeStatus(rentalType) {
            let id = rentalType.id;
            rentalType.disabled = !rentalType.disabled;
            axios.put(this.$routes.route('rentaltype.update', {'rentalType': id}), rentalType)
                .then(response => {
                    this.fetchRentalTypes();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteRentalType(rentalType) {
            let id = rentalType.id;
            axios.delete(this.$routes.route('rentaltype.destroy', {'rentalType': id}))
                .then(response => {
                    this.fetchRentalTypes();
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.loading = true;
        this.fetchRentalTypes();
    },
}
</script>